import { Flexbox } from '@luminovo/design-system';
import { styled } from '@mui/material';

export const ActionsContainer = styled(Flexbox)({
    gap: '4px',
    alignItems: 'center',
    justifyContent: 'end',
});
